<style>
  .singleGrid .k-grid-aria-root {
  overflow-x: auto !important;
  overflow-y: auto !important;
  margin-bottom: 45px;
}

.singleGrid .k-header {
width: 200px;
}

.singleGrid .k-grid-header {
position: sticky;
top: 0;
z-index: 100;
}

td {
width: 100%
}
</style>

<div class="row importPage">
  <div class="col-12">
    <div class="row">
      <div class="col-12">
        <div class="">
          @if (!showTextBox) {
            <div (dblclick)="showTextbox()" class="topGreySection">{{title}}</div>
          }
          <div>
            @if (showTextBox) {
              <input class="mt-3 mb-2" type="text"
                #titleTextBox
                [value]="title"
                id="titleTextBox"
                (blur)="closeTextbox($event.target)"
                (keyup.enter)="closeTextbox($event.target)" />
            }
          </div>

        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="bordered_sections">
          <div class="col-12 import_title">Follow the Steps</div>
          <kendo-stepper [steps]="_steps" [stepType]="'full'" [(currentStep)]="_currentStep" (currentStepChange)="_currentStepChange()" [linear]="false">
          </kendo-stepper>
        </div>
      </div>
    </div>
    <!-- <div class="col-12">
    <div class="hr_separator"></div>
  </div> -->

  @if (_currentStep == 0) {
    <div class="col-12">
      <div class="row">
        <div class="col-12">
          <p class="step_title">Step 1:</p>
        </div>
        <div class="col-12">
          <div class="row">
            <div [ngClass]="(_currentUser && _currentUser.isEnterprise) ? 'col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3' :  'col-12'">
              <div class="container_box import-step" [class.active]="_currentBox == 1">
                <div class="row">
                  <div class="col-12">
                    <p class="import-title-header">Select One Form to Continue</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      @for (key of _fileMapKeys; track key) {
                        <div class="col-12 col-height">
                          <input type="radio" name="imported-file" [value]="key" id="{{key}}"
                            (click)="GetGridFieldForImport(key)" [formControl]="_fileSelected" kendoRadioButton />
                            <label for="{{key}}" class="k-radio-label">{{_fileMapList[key].modelName}}</label>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              @if (_currentUser && _currentUser.isEnterprise) {
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9 specialColPadright"
                  >
                  <div class="container_box import-step" [class.active]="_currentBox == 2">
                    <div class="row">
                      <div class="col-12">
                        <p class="import-title-header">Select Accounts And Sites </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        @if (_showAccountsGrid) {
                          <asap-account-sites-selection
                            [selectedAccounts]="importAccounts"
                            [disabled]="!_enableSiteSelection"
                            [resolver]="_getAccounts"
                            (onRowSelectionChanges)="_onAccountRowSelectionChanges($event)"
                            class="singleGrid">
                          </asap-account-sites-selection>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }

    @if (_currentStep == 1) {
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <p class="step_title">Step 2:</p>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3 specialColPadLeft">
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-12 margin_button_8">
                    <div class="container_box">
                      <div class="col-12 margin_button_10">
                        <div class="row no-margin">
                          <div class="col-12 col-sm-4 col-md-3 col-lg-4 col-xl-5 nopad">
                            <label class="steps_grey_label" [for]="'Importinfo'">
                              Import Info:
                            </label>
                          </div>
                          <div class="col-12 col-sm-8 col-md-9 col-lg-8 col-xl-7 nopad">
                            <input class="steps_grey_input" id="Importinfo" [value]="_modelName" disabled />
                          </div>
                        </div>
                      </div>
                      <div class="col-12 margin_button_10">
                        <div class="row no-margin">
                          <div class="col-12 col-sm-4 col-md-3 col-lg-4 col-xl-5 nopad">
                            <label class="steps_grey_label" [for]="'Source'">
                              Source:
                            </label>
                          </div>
                          <div class="col-12 col-sm-8 col-md-9 col-lg-8 col-xl-7 nopad">
                            <input class="steps_grey_input" id="Source" value="Excel" disabled />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-12 margin_button_20">
                    <div class="container_box import-step" [class.active]="_currentBox == 3">
                      <div class="col-12 margin_button_10">
                        <asap-import-input (fileSelectedChanges)="_fileSelectedChanges($event)">
                        </asap-import-input>
                      </div>
                      <div class="col-12 nopad pad_left_15 pad_right_15">
                        <div class="row no-margin">
                          <div class="hr_separator"></div>
                        </div>
                      </div>
                      <div class="col-12 margin_button_10">
                        <div class="row no-margin">
                          <div class="col-12 nopad">
                            <label class="steps_grey_label" [for]="'Source'">Tabs</label>
                          </div>
                          <div class="col-12 nopad">
                            @for (name of _sheetNames; track name; let i = $index) {
                              <div class="wrap">
                                <input type="radio" name="file-sheet" [formControl]="_fileSheetSelected"
                                  [value]="i" [id]="'sheet' + i" kendoRadioButton />
                                  <label class="k-radio-label" [for]="'sheet' + i">{{name}}</label>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9 margin_button_8 specialColPadright">
                  <div class="container_box">
                    <div class="col-12 margin_button_10">
                      <div class="row no-margin">
                        <p class="table_title_text">
                          Data
                          <span>
                            (only the first 5 rows of the imported sheet are being shown)
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row no-margin">
                        <kendo-grid #grid [data]="_dataGrid">
                          @for (col of _gridColumns; track col) {
                            <kendo-grid-column [field]="col" [title]="col"></kendo-grid-column>
                          }
                        </kendo-grid>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      @if (_hasMappingLicense ? _currentStep == 2 : false) {
        <stocks-import-map-fields [_mappedFields]="mappedFields"
          [ImportMapList]="ImportMapList"
          [_StockLocationMinMaxFields]="StockLocationMinMaxFields"
          [_AssignAssetFields]="AssignAssetFields" [_CopySelectedModelsColumns]="CopySelectedModelsColumns"
          [_selectedModel]="selectedModel">
        </stocks-import-map-fields>
      }

      @if (_hasMappingLicense ? _currentStep == 3 : _currentStep == 2) {
        <stocks-import-validation [_mappedFields]="mappedFields" [_selectedModel]="selectedModel" #importValidationComponent>
        </stocks-import-validation>
      }

      @if (_hasMappingLicense ? _currentStep == 4 : _currentStep == 3) {
        <stocks-import-send-data></stocks-import-send-data>
      }

      <div class="col-12 buttonsSection" style="margin-top: 10px">
        @if (_currentStep < (_hasMappingLicense ? 4 : 3) && _canGoNext) {
          <button kendoButton class="steps_buttons_class" (click)="_next()">
            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/next-icon.svg'" />
            <span>{{(_canGoNext && _currentStep == (_hasMappingLicense ? 3 : 2)) ? 'Import' : 'Next'}}</span>
          </button>
        }
        @if (_hasMappingLicense && _currentStep == 2) {
          <button kendoButton class="steps_buttons_class" (click)="_openSaveMap()">
            <span>Save Map</span>
          </button>
        }
        @if (_currentStep == (_hasMappingLicense ? 3 : 2) && !_canGoNext) {
          <button kendoButton class="steps_buttons_class" (click)="_reValidate()">
            Re-Validate
          </button>
        }
        @if (_currentStep > 0 && _currentStep < (_hasMappingLicense ? 4 : 3)) {
          <button kendoButton class="steps_buttons_class" (click)="_back()">
            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/back-icon.svg'" />
            <span>Back</span>
          </button>
        }
        <button kendoButton class="steps_buttons_class" (click)="_close()">
          <img class="backimage" [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
          <span>Close</span>
        </button>
      </div>
    </div>
  </div>

  @if (showSaveMap) {
    <kendo-window [width]="750" (close)="_closeSaveMap()" (keydown.enter)="$event.preventDefault()" style="z-index:100005">
      <div class="col-12 form-group">
        <div style="margin-top: 10px;  margin-right: 5px;">
          <button (click)="_closeSaveMap()" kendoButton class="steps_buttons_class">
            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
            <span>close</span>
          </button>
          <button (click)="saveMap()" kendoButton class="steps_buttons_class">
            <span><img class="backimage" [src]="'/assets/menu/'+ _theme +'/print-icon.svg'" /></span> Save Map
          </button>
        </div>
        <label class="control-label trl" style="margin-top: 15px;">Map Name</label>
        <input type="text" class="k-textbox writebox min-width-0 newFormControlWidth"
          [placeholder]="'Map Name'" [(ngModel)]="selectedMap" [ngModelOptions]="{standalone: true}"
          entityName="code" required />
        </div>
      </kendo-window>
    }
